import { render } from "./ActivityLayout.vue?vue&type=template&id=1e06acac&scoped=true"
import script from "./ActivityLayout.vue?vue&type=script&lang=js"
export * from "./ActivityLayout.vue?vue&type=script&lang=js"

import "./ActivityLayout.vue?vue&type=style&index=0&id=1e06acac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e06acac"

export default script